
import React, { useState, useEffect, useRef } from 'react'
import { MessageProps } from '../../MessageDisplayArea'
import { SpinnerIcon } from '../../../../components/icons'

const TIME_BEFORE_SPINNER_LAUNCH = 1e3;

const Spinner: React.FC<MessageProps> = props => {
  const {
    message: {
      isFake,
    }
  } = props;

  const [isShowSpinner, setIsShowSpinner] = useState<boolean>(false);
  const waitingToTurnSpinnerRef = useRef<number | undefined>(undefined);

  useEffect(() => {
    if (isFake) {
      waitingToTurnSpinnerRef.current = setTimeout(() => {
        if (isFake) {
          setIsShowSpinner(true);
        }
      }, TIME_BEFORE_SPINNER_LAUNCH) as unknown as number;
    }

    return () => {
      clearTimeout(waitingToTurnSpinnerRef.current);
    };
  }, []);

  if (!isShowSpinner) return null
  return <SpinnerIcon />
};

export default Spinner
